const customContentStyle = {
  zIndex: 2,
  width: '460px'
}
export { customContentStyle }
